import React from 'react'
import KeyValueTable from '../DataPresenters/keyValueTable'
import GridedRow from '../GridedRow/GridedRow'

import ViewSupportTicketStatusForm from './ViewSupportTicketStatusForm'

import {
  typeRenderer,
  statusRendererWithColor,
  dateRenderer,
} from './helpers'

const ViewSupportTicketMeta = ({ticket, isUserManager, status}) => {
  const selectedStatusRenderer = isUserManager
    ? <ViewSupportTicketStatusForm ticket={ticket} status={status} />
    : statusRendererWithColor

  const propertiesToShow = [
    [
      { key: 'title', title: 'عنوان' },
      { key: 'ticket_type', title: 'نوع', renderer: typeRenderer },
    ],
    [
      { key: 'ticket_code', title: 'کد تیکت' },
      // { key: 'ticket_status', title: 'وضعیت', renderer: statusRenderer },
      { key: 'ticket_status', title: 'وضعیت', renderer: selectedStatusRenderer },
    ],
    [
      { key: 'created_at', title: 'ایجاد شده در', renderer: dateRenderer },
      { key: 'updated_at', title: 'آخرین بروز رسانی', renderer: dateRenderer },
    ],
  ]

  return (<div className="meta">
    <GridedRow columns={3}>
      <KeyValueTable data={ticket} propertiesToShow={propertiesToShow[0]} />
      <KeyValueTable data={ticket} propertiesToShow={propertiesToShow[1]} />
      <KeyValueTable data={ticket} propertiesToShow={propertiesToShow[2]} />
    </GridedRow>
  </div>)
}

export default ViewSupportTicketMeta


// WEBPACK FOOTER //
// ./src/components/common/Support/ViewSupportTicketMeta.js